import { useState } from 'react'

import {
	EuiModalBody,
	EuiModalFooter,
	EuiButton,
} from '@equipmentshare/ds2'

import ResourcePicker from '../../../components/ResourcePicker'
import RolePicker from '../../../components/RolePicker'

import { Resource, Role, Group } from 'graphql'
import useAddPolicyHandler from '../../effects/add-policy-to-group'

import styles from './addPolicy.module.css'
import { heapEvent } from '@equipmentshare/heaper'

export type AddPolicyFormProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onConfirm: () => void,
	group: Group,
}

export default function AddPolicyForm( { onCancel, onSuccess, onConfirm, group }: AddPolicyFormProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const [ selectedRole, setSelectedRole ] = useState<Role | undefined>()
	const [ selectedResource, setSelectedResource ] = useState<Resource | undefined>()

	const addPolicy = useAddPolicyHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Add Policy to Group Modal - Click - Submit', {} )
		setIsSaving( true )
		const result = await addPolicy( group, selectedRole?.id ?? 0, selectedResource?.id ?? 0 )
		setIsSaving( false )
		onConfirm()
		onSuccess()
		return result
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Add Policy to Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<>
			<EuiModalBody>
				<RolePicker
					className={styles.autoComplete}
					label="Select Role"
					onChange={( _?: number, role?: Role ) => setSelectedRole( role )}
					selectedRole={selectedRole}
				/>
				<ResourcePicker
					className={styles.autoComplete}
					label="Select Resource"
					onChange={( _?: number, resource?: Resource ) => setSelectedResource( resource )}
					selectedResource={selectedResource}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButton
					id="cancelBtn"
					color="text"
					onClick={handleCancel}
				>
					Cancel
				</EuiButton>
				<EuiButton
					id="submitBtn"
					fill
					onClick={handleSubmit}
					isLoading={isSaving}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
